import React, { useEffect } from 'react'
import {useParams, useHistory} from 'react-router-dom'
import Layout from '../../components/Layout'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import BeatPlanForm from './BeatPlanForm'
import { isArray, ROUTES, uploadFilesToAws } from '../../shared/constants'
import {UseBeatPlan} from '../../hooks/beatPlan/useBeatPlan'
export default function AddBeatPlan({ currentPlan }) {
  const formSchema= {
    channelName: '',
    channelType: '',
    status: '',
    city: null,
    state: null,
    employee: '',
    action: '',
    date: new Date(),
  }
  const [form, setform] = React.useState(formSchema)
  const [editForm, setEditForm] = React.useState(formSchema)
  const history = useHistory();
  const {addBeatPlan, editBeatPlan, getAllBeatPlan, getSingleBeatPlan, beatPlan, loading } = UseBeatPlan();
  const handleRequest = async () => {
    if(id!== undefined){
      console.log("editing")
      console.log(editForm);
      editBeatPlan({id: id, ...editForm}, id)
    }
    else {
      console.log("adding beat plan")
      addBeatPlan(
        {...form}
      )
    // history.push(ROUTES.BEAT_PLANS)
    }
  } 
  const {id}= useParams()
  useEffect(()=>{
    if(id !== undefined){
      let item= getSingleBeatPlan(id)
      console.log(item);
      if(item!== null){
      setEditForm({
          channelName: item.channelName._id,
          channelType: item.channelType._id,
          city: item.city._id,
          state: item.state._id,
          employee : item.employee._id,
          date: item.date,
        })
      }
    }
  }, [id])
  return (
    <Layout heading={`Beat Plan`} heading2={` ${id!== undefined ? 'Edit' : 'Add'}`} url1={ROUTES.BEAT_PLANS} none>
      <HeaderTabLayout
        heading={`${id !== undefined ? 'Edit' : 'Add'}  Beat `}
        state = {form}
        setState = {id!==undefined? setEditForm : setform}
        content={
        <BeatPlanForm state={id!==undefined? editForm : form} setState={id!==undefined? setEditForm : setform} />
        }
        addContent={handleRequest}
        text={`${id!== undefined ? 'Update' : 'Add'}`}
        redirect={ROUTES.BEAT_PLANS}
        loading={loading}
      />
    </Layout>
  )
}
